import { render } from "./Sale_Penalties.vue?vue&type=template&id=6a24850e&scoped=true"
import script from "./Sale_Penalties.vue?vue&type=script&lang=js"
export * from "./Sale_Penalties.vue?vue&type=script&lang=js"

import "./Sale_Penalties.vue?vue&type=style&index=0&id=6a24850e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a24850e"]])

export default __exports__